<template>
  <v-layout row align-center justify-start class="permissions-warning">
    <v-icon small class="pr-2">lock</v-icon>
    <span>
      {{ permission ? permission : $t("NoPermissionDefaultWarning") }}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: "AppNoPermissionWarning",

  props: {
    /**
     * Missing permission
     */
    permission: {
      type: String
    }
  }
};
</script>

<style scoped>
.permissions-warning {
  padding: 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Molecules/AppNoPermissionWarning.vue